import { AdminRescheduleAction } from "./AdminRescheduleAction"
import { CancelAction } from "./CancelAction"
import { ChangeTypeAction } from "./ChangeTypeAction"
import { LinkRescheduledAction } from "./LinkRescheduledAction"
import { ReassignAction } from "./ReassignAction"
import { RescheduleAction } from "./RescheduleAction"
import { StatusAction } from "./StatusAction"
import type { BookingAction, BookingActionId } from "./types"

/**
 * The appointment dialog's writes, in the order their triggers are drawn. Each lives in its own file;
 * adding one is a new file and a line here.
 */
export const bookingActions: readonly BookingAction[] = [
  CancelAction,
  ReassignAction,
  StatusAction,
  RescheduleAction,
  AdminRescheduleAction,
  ChangeTypeAction,
  LinkRescheduledAction,
]

export function findBookingAction(id: BookingActionId): BookingAction | undefined {
  return bookingActions.find(action => action.id === id)
}
